import type { BaseSearchParamsWithoutQuery } from '@algolia/client-search';
import type { Satisfies } from '@iheartjane/types';

import { getAlgoliaClient } from './client';
import type { AlgoliaConfig } from './client';

type FacetOptions = Satisfies<
  {
    /**
     * Search for entries around a central geolocation, enabling a geo search within a circular area.
     */
    aroundLatLng?: string;
    /**
     * Define the maximum radius for a geo search (in meters).
     */
    aroundRadius?: number | 'all';
    /**
     * A user identifier.
     * Format: alpha numeric string [a-zA-Z0-9_-]
     * Length: between 1 and 64 characters.
     */
    userToken?: string;
  },
  BaseSearchParamsWithoutQuery
>;

export interface FacetProps {
  indexPrefix?: string;
  options?: FacetOptions;
  requestedFacets?: string[];
  searchText?: string | null;
  staticFilters?: string;
}

export const fetchFacets = async (
  config: AlgoliaConfig,
  {
    indexPrefix = 'menu-products-',
    options,
    requestedFacets = ['*'],
    searchText,
    staticFilters,
  }: FacetProps
) => {
  const client = getAlgoliaClient(config);
  const indexName = `${indexPrefix}${config.algoliaEnv}`;

  const query = searchText ?? '';
  const { facets } = await client.searchSingleIndex({
    indexName,
    searchParams: {
      facets: requestedFacets,
      filters: staticFilters,
      query,
      ...options,
    },
  });

  return facets;
};
